<template>
  <section class="insured-form">
    <el-form
      ref="form"
      :rules="rules"
      :disabled="disabled"
      :model="formData">
      <div class="insured-container">
        <div
          v-for="(item, index) in formData.nm_pa_list"
          :key="index"
          class="card"
        >
          <span class="title">Insured {{ index+1 }}</span>
          <div class="form-item">
            <span>Relationship with Policyholder</span>
            <el-form-item
              :ref="`nm_pa_list.${index}.rel_id`"
              :rules="rules.rel_id"
              :prop="'nm_pa_list.' + index + '.rel_id'" >
              <v-select
                v-model="item.rel_id"
                :list="
                  index == 0
                    ? relationOptionsSelf
                    : getRelationOptionsOther(item.age_type)
                "
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Title</span>
            <el-form-item
              :ref="'nm_pa_list.' + index + '.title'"
              :rules="rules.title"
              :prop="'nm_pa_list.' + index + '.title'" >
              <v-select
                v-model="item.title"
                :list="carTitleOptions"
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Last Name</span>
            <el-form-item
              :ref="'nm_pa_list.' + index + '.lst_nm'"
              :rules="rules.lst_nm"
              :prop="'nm_pa_list.' + index + '.lst_nm'" >
              <v-input
                v-model="item.lst_nm"
                uppercase
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>First Name</span>
            <el-form-item
              :ref="'nm_pa_list.' + index + '.fst_nm'"
              :rules="rules.fst_nm"
              :prop="'nm_pa_list.' + index + '.fst_nm'" >
              <v-input
                v-model="item.fst_nm"
                uppercase
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Date of Birth</span>
            <el-form-item
              :ref="'nm_pa_list.' + index + '.dob'"
              :rules="rules.dob"
              :prop="'nm_pa_list.' + index + '.dob'" >
              <v-birth-day
                v-model="item.dob"
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
          </div>
          <div class="form-item">
            <!--            <span>HKID/Passport Number</span>-->
            <el-form-item
              :ref="'nm_pa_list.' + index + '.id_type'"
              :rules="rules.id_type"
              :prop="'nm_pa_list.' + index + '.id_type'" >
              <v-radio-group
                v-model="item.id_type"
                :list="personalIdTypOptions"
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
            <el-form-item
              :ref="'nm_pa_list.' + index + '.id_no'"
              :rules="rules.id_no"
              :prop="'nm_pa_list.' + index + '.id_no'" >
              <v-input
                v-model="item.id_no"
                class="mg-t-5"
                uppercase
                :placeholder="item.id_type==1?'A123456(3), please input A1234563':''"
                :disabled="index == 0 && disabledHldrPa" />
            </el-form-item>
          </div>
          <div class="form-item">
            <span>Occupation</span>
            <el-form-item
              :ref="'nm_pa_list.' + index + '.occ_id'"
              :rules="rules.occ_id"
              :prop="'nm_pa_list.' + index + '.occ_id'" >
              <v-select
                v-model="item.occ_id"
                :disabled="(index == 0 && disabledHldrPa) ||  item.age_type == 2"
                :list="occupation(item.age_type)"/>
            </el-form-item>
          </div>
        </div>
      </div>
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'

export default {
  name: 'InsuredForm',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    formDataLock: {
      type: Number,
      default: 0
    },
    policyOneInsured: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        nm_pa_list: []
      },
      init: false, // 標記是否已經初始化過
      rules: {
        rel_id: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        title: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        lst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        fst_nm: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        dob: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_type: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        id_no: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        occ_id: [
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
      },
      oldFormDataLock: -1,
      relation: [],
      allRelation: [],
    }
  },
  computed: {
    relationList() {
      return index=>{
        const data = this.allRelation||[]
        const other =  data.filter(item => item.is_insured != 1)
        if(index==0){
          return data
        }else{
          return  other
        }
      }
    },
    classId() {
      return this.form.class_id
    },
    localAllOptions() {
      return this.allOptions27
    },
    occupation(){
      return (type)=>{
        let {child_occupation,occupation  } = this.localAllOptions||{}
        return type==2?child_occupation:occupation
      }
    },
    paItemDefault(){
      return {
        rel_id: '',
        title: '',
        lst_nm: '',
        fst_nm: '',
        id_no: '',
        id_type: 1,
        occ_id : '',
        id_type_pic_path: '',
        id_type_pic_path_id: '',
        id_type_pic_url: '',
        id_type_pic_thumb_url: '',
        id_type_pic: null,
      }
    },
    disabledHldrPa(){
      const { hldr_is_pa_ind } = this.form || {}
      return hldr_is_pa_ind == 1
    },
    occOptionsAdult(){
      const { occupation } = this.localAllOptions || {}
      return occupation || []
    },
    occOptionsChild(){
      const { child_occupation } = this.localAllOptions || {}
      return child_occupation || []
    },
    relationOptions(){
      const { relation } = this.localAllOptions || {}
      return relation || []
    },
    relationOptionsSelf(){
      return this.relationOptions.filter(v => v.id == 1)
    },
    relationOptionsAdult(){
      return this.relationOptions.filter(v => v.id == 2)
    },
    relationOptionsChild(){
      return this.relationOptions.filter(v => v.id == 3)
    },
  },
  watch: {
    // 表單鎖，外層會更新，數值變化了才可以更新 formData
    formDataLock: {
      handler(val, old = -1) {
        if(val !== old) {
          this.oldFormDataLock = old
        }
      }
    },
    form: {
      deep: true,
      immediate: true,
      handler(val) {
        if(val.cust_typ) {

          this.allRelation = this.allOptions.relationship.person
        }
        if(this.formDataLock !== this.oldFormDataLock) {
          // 觸發更新就賦值，避免二次更新
          this.oldFormDataLock = this.formDataLock
          Object.keys(this.formData).some(key => {
            if(key in val) {
              this.formData[key] = val[key]
            }
          })


          // 只需要初始化第一次
          if(this.init) {
            return
          }
          console.log('init')
        }
      }
    },
    policyOneInsured: {
      immediate: true,
      handler(status) {
        if(status) {
          setTimeout(() => {
            this.formData.nm_pa_list[0].rel_id = 1
          },500)
        }
      }
    }
  },
  created() {
    this.init = false
  },
  methods: {
    getRelationOptionsOther(age_type){
      if(age_type == 1){
        return this.relationOptionsAdult
      }else if(age_type == 2){
        return this.relationOptionsChild
      }
      return []
    },
    initFirstInsured(){
      const {isrd_title, isrd_lst_nm, isrd_fst_nm, id_no, isrd_dob, id_type, occ_id,id_type_pic = {}} = this.form||{}
      const {id, path, url, thumb_url} = id_type_pic || {}

      const firstInsured = this.formData.nm_pa_list[0] || {}

      let result = {
        ...this.paItemDefault,
        ...firstInsured,
        rel_id: 1,
        title: isrd_title,
        lst_nm: isrd_lst_nm,
        fst_nm: isrd_fst_nm,
        id_no: id_no,
        id_type: id_type,
        dob: isrd_dob,
        occ_id,
        id_type_pic_path: path,
        id_type_pic_path_id: id,
        id_type_pic_url: url,
        id_type_pic_thumb_url: thumb_url,
        id_type_pic: id_type_pic,
      }



      this.$set(this.formData.nm_pa_list, 0, result)
    },
    handlerInitNmPaList(data){
      if(!this.isFamily) return
      const { nm_pa_list } = data || {}
      const paList = nm_pa_list || []
      let arr = []
      paList.forEach(item => {
        const { id_type_pic_path, id_type_pic_url, id_type_pic_thumb_url} = item
        arr.push({
          ...this.paItemDefault,
          ...item,
          ...(id_type_pic_thumb_url ? {
            id_type_pic : {
              path : id_type_pic_path,
              url : id_type_pic_url,
              thumb_url : id_type_pic_thumb_url,
            }
          } : {})
        })
      })
      this.formData.nm_pa_list = arr
    },
    submitForm(formName) {
      this.$refs.form.validate((valid, rules) => {
        if(valid) {
          const { nm_pa_list } = this.formData
          this.init = true
          this.$emit('getFormData', formName, {
            no_of_pa: nm_pa_list.length,
            nm_pa_list
          })
        }
        else {
          this.scrollToValidDom(rules)
        }
      })

    },
    getSaveSubmitForm(formName){
      const { nm_pa_list } = this.formData
      this.init = true
      this.$emit('getFormData', formName, {
        no_of_pa: nm_pa_list.length,
        nm_pa_list
      })
    },

    handlerPolicyInsuredInfo(data) {
      const {
        id_no, id_type, isrd_dob, isrd_fst_nm, isrd_lst_nm, isrd_title, occ_id,hldr_is_pa_ind,
        id_type_pic
      } = data

      const { id, path } = id_type_pic || {}
      // 避免二次觸發 form 數據更新，影響 document 組件 司機數據
      if(hldr_is_pa_ind == 1) {

        Object.assign(this.formData.nm_pa_list[0], {
          rel_id: 1,
          dob: isrd_dob,
          fst_nm: isrd_fst_nm,
          id_no: id_no,
          id_type: id_type,
          lst_nm: isrd_lst_nm,
          occ_id: occ_id,
          title: isrd_title,
          id_type_pic_path_id: id,
          id_type_pic_path: path,
        })
      }

    },
  }
}
</script>
<style lang="scss" scoped>
  .insured-form {
    .title {
      display: block;
      padding-bottom: 15px;
      color: #616266;
      font-size: 20px;
      font-weight: 500;
    }
    .form-flex {
      display: flex;
      justify-content: space-between;
      & > .form-block {
        margin-right: 15px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
    .form-block {
      margin-bottom: 16px;
      & > span:first-child {
        display: block;
        padding-bottom: 5px;
        font-weight: 500;
        font-size: 14px;
        color: #616266;
      }
    }
    .insured-container {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .card {
        position: relative;
        margin-bottom: 15px;
        width: calc(50% - 10px);
        .driver-switch {
          position: absolute;
          top: 15px;
          right: 15px;
        }
        .mask {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          top: 50px;
          z-index: 2;
          background: rgba(255, 255, 255, 0.7);
        }
      }
    }
  }
</style>
